<template>
  <div class="min-h-screen bg-gray-100">
    <TopBar :role="this.role" :user-data="this.userData.data" v-if="userData && role"/>
    <main class="max-w-3xl m-auto shadow-sm rounded-xl bg-white mt-5">
      <div class="px-5 py-4 text-center border-b">
        <h1 class="text-lg font-medium text-neutral-700">Configuración</h1>
      </div>
      <div class="p-6 pb-9">
        <UserSettingsForm :userData2="userData2"/>
      </div>
    </main>
  </div>
</template>

<script>
import TopBar from "../dashboard/components/TopBar.vue";
import UserSettingsForm from "./components/UserSettingsForm.vue";

export default {
  name: "UserSettings",
  components: {
    TopBar,
    UserSettingsForm,
  },
  data() {
    return {
      role: null,
      userData: null,
      userData2: null
    }},
  mounted() {
    this.role = window.localStorage.getItem("role");
    this.userData = JSON.parse(window.localStorage.getItem("auth"));
    const authData = window.localStorage.getItem("auth");

    if (authData) {
      this.userData2 = JSON.parse(authData).data; // Accediendo a la propiedad 'data'
    }
  }
};
</script>
